import axios from 'axios'

import { getBaseUrl } from 'utils/baseUrls'

const { NODE_ENV } = process.env
const GREMLIN_AGENT = `support/${NODE_ENV}`
const HOSTNAME_REGEX = /(.*\w\.|.*\/)gremlin\.com/

const baseURL = `${getBaseUrl('support')}/v1`
const API = axios.create({
  baseURL,
  adapter:
    process.env.NODE_ENV === 'test'
      ? require('axios/lib/adapters/http')
      : require('axios/lib/adapters/xhr')
})

// When using hot reloading, interceptors do not get cleared. Therefore after
// a few reloads requests will behave erratically as they're being caught
// multiple times.
API.interceptors.request.handlers = []
API.interceptors.response.handlers = []
API.interceptors.request.use((config) => {
  if (HOSTNAME_REGEX.test(config.url)) {
    config.headers['X-Gremlin-Agent'] = GREMLIN_AGENT // eslint-disable-line no-param-reassign
  }
  return config
})

export default API
